import { render, staticRenderFns } from "./WideLayout.vue?vue&type=template&id=6cabc6a2&lang=pug&"
import script from "./WideLayout.vue?vue&type=script&lang=ts&"
export * from "./WideLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PageBreadcrumbs: require('/var/www/2k.sitisit.ru/frontend/2000koles-front-20240913150231/node_modules/sitis-nuxt/lib/cms/PageBreadcrumbs.vue').default,LayoutPlaceholder: require('/var/www/2k.sitisit.ru/frontend/2000koles-front-20240913150231/cms/LayoutPlaceholder.vue').default})
